export default __webpack_public_path__ + "static/media/seventeen.ab675429.png";